/**
 * Décompte des pièces d'un dossier, à partir des tuiles calculées par
 * `PiecesGrid`.
 *
 * Le dénominateur est le nombre de pièces REQUISES pour ce dossier précis :
 * `PiecesGrid` a déjà retiré le contrôle technique non exigible, remplacé le
 * permis et le justificatif par le Kbis pour un acquéreur personne morale,
 * ajouté le récépissé du parcours A, l'hébergeur, le co-titulaire et les versos
 * attendus. Compter les lignes d'extraction à la place donnait « 9/9 » sur un
 * dossier où la carte grise manquait : un recto et un verso font deux lignes
 * pour une seule pièce, et le 9 était figé quel que soit le parcours.
 */
export interface PieceStatusLike {
  status: 'conforme' | 'attention' | 'blocage' | 'absent';
}

export interface PieceCounts {
  present: number;
  required: number;
}

/**
 * Une pièce déposée compte comme présente même si elle porte une alerte ou un
 * blocage : le compteur répond à « qu'est-ce qui manque ? », pas à « qu'est-ce
 * qui est valide ? ». La qualité est déjà portée par les KPI conformes /
 * attention / blocages juste à côté, et un dossier complet mais imparfait doit
 * afficher un compteur plein.
 */
export const countPieces = (tiles: PieceStatusLike[]): PieceCounts => ({
  present: tiles.filter((tile) => tile.status !== 'absent').length,
  required: tiles.length,
});
